import NumberInput from "../../../../../util/component/NumberInput";
import { FormNumberInputProps } from "./Types";
import { destructProps, useFormInputs } from "./Utils";
import i18n from "i18next";

const FormNumberInput = (props: FormNumberInputProps) => {
  const { formProps, baseProps } = destructProps(props);

  const form = useFormInputs(formProps);

  const error = baseProps.error || !!form?.error;
  const helperText = baseProps.helperText || form?.error?.message?.toString() || "";
  
  return (
    <NumberInput
      {...baseProps}
      onChange={(value: number) => form?.onChange && form.onChange(value)}
      minValue={baseProps.minValue}
      maxValue={baseProps.maxValue}
      defaultValue={form?.value}
      disabled={baseProps.disabled}
      label={baseProps.label || ""}
      error={error}
      helperText={String(helperText)}
      acceptDecimal={true}
      handleComma={i18n.language.includes("it")}
    />
  );
};

export default FormNumberInput;
